import request from "./request";

export const translation = (lang: string, text: string) => {
    return request('get', '/api/user/services/translation', {lang, text})
        .then(data => {
            return data.data
        })
}